const testimonials = [
  {
    id: "1",
    name: "JC Rolison",
    text: "We outsourced part of our development for mobile development. Noor-e-Iqra worked on Android development, and functionality through Codebusters. She is very skillful, extremely fast learning, and works well in midsize team environments. She is one of the best Junior developers that our team has worked with.",
    country: "New York",
    url: "https://www.linkedin.com/in/noor-e-iqra",
  },
  {
    id: "2",
    name: "Junaid Qureshi",
    text: "I highly recommend Noor-e-Iqra to every person out there looking for an amazing problem solver and a Developer. We've studied together and I can count on her dedication to learning, growing, and solving problems related to programming.",
    country: "Pakistan",
    url: "https://www.linkedin.com/in/noor-e-iqra",
  },

]

export default testimonials
